export default "__VITE_ASSET__ca1462d1__"